import React, { useState, useEffect } from "react";
import Head from "../Components/Head";
import { HiFlag, HiOutlineTrash } from "react-icons/hi";
import { FiEdit3 } from "react-icons/fi";
import NoteModal from "../Modals/NoteModal";
import notesService from "../Services/notesService";
import DeleteNoteModal from "../Components/DeleteNoteModal";

const Notes = () => {
  const [notes, setNotes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [note, setNote] = useState({
    title: "",
    description: "",
    priority: "",
  });

  const handleSave = () => {
    // Close modal and reset form after save
    setShowModal(false);
    setNote({ title: "", description: "", priority: "" });

    // Refetch notes from DB after saving new one
    notesService.fetchAll().then((res) => {
      setNotes(res.notes);
    });
  };

  useEffect(() => {
    notesService.fetchAll().then((res) => {
      console.log(res);
      setNotes(res.notes);
    });
  }, [trigger]);

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "low":
        return "text-green-500";
      case "medium":
        return "text-yellow-500";
      case "high":
        return "text-orange-500";
      case "urgent":
        return "text-red-500";
      default:
        return "text-gray-400";
    }
  };

  const initiateDelete = (id) => {
    setOpen(true);
    setDeleteID(id);
  };

  const handleDelete = () => {
    setDeleting(true);
    notesService.delete(deleteID).then(() => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  return (
    <main className="mx-10 p-6 mt-2 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <Head
        heading={"Notes"}
        button_text={"Add Note"}
        navigation={() => setShowModal(true)}
      />

      <DeleteNoteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />

      <div className="table-div">
        <table className="w-full">
          <thead className="border-y-2 text-left text-black text-[10px]">
            <tr className="uppercase">
              <th className="rounded-tl-lg py-4 pl-4 w-[25%]">Title</th>
              <th className="py-4 w-[50%]">Description</th>
              <th className="py-4 text-center w-[10%]">Priority</th>
              <th className="py-4 text-center w-[15%]">Options</th>
            </tr>
          </thead>
          <tbody>
            {notes?.map((value, index) => (
              <tr
                key={value.id}
                className="bg-accent border-b border-gray-100 text-left"
              >
                <td className="py-4 pl-4 font-bold">
                  {value.title || (
                    <span className="text-gray-400 italic">No title</span>
                  )}
                </td>
                <td className="py-4">
                  {value.description || (
                    <span className="text-gray-400 italic">No description</span>
                  )}
                </td>
                <td className="py-4 text-center">
                  <HiFlag
                    className={`h-6 w-6 mx-auto ${getPriorityColor(value.priority)}`}
                  />
                </td>
                <td className="py-4 text-center">
                  <div className="flex justify-center gap-6">
                    <button
                      onClick={() => {
                        setNote(value); // Set current note
                        setShowModal(true); // Open modal
                      }}
                    >
                      <FiEdit3 className="h-4 w-4 text-indigo-500" />
                    </button>
                    <button onClick={() => initiateDelete(value.id)}>
                      <HiOutlineTrash className="h-4 w-4 text-red-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {notes.length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  className="py-6 text-center text-gray-400 italic"
                >
                  No notes found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal to add new note */}
      <NoteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSave}
        note={note}
        setNote={setNote}
      />
    </main>
  );
};

export default Notes;
